import axios from 'axios';

export const authService = {
  login: (credentials) =>
    axios.post('/auth/login', credentials),

  register: (data) =>
    axios.post('/auth/register', data),

  getMyProfile: () =>
    axios.get('/auth/me', { auth: true }),
};
